import { Component } from "@angular/core";
import { ɵYearHeaderComponent as YearHeaderComponent } from "ng-zorro-antd/date-picker";

@Component({
  selector: "ui-year-header",
  exportAs: "uiYearHeader",
  templateUrl: "../date-header/date-header.component.html",
})
export class UiYearHeaderComponent extends YearHeaderComponent {}
